import { isProd, wpApiBase } from '@/config';
import axios from 'axios';

export interface RouteData {
  acf: any;
  author: number;
  content: { protected: boolean; rendered: string };
  date: string;
  excerpt: { protected: boolean; rendered: string };
  featured_media: number;
  id: number;
  menu_order: number;
  meta: any[];
  modified: string;
  parent: number;
  slug: string;
  status: string;
  title: { rendered: string };
  type: string;
}

export default class Wordpress {
  static apiBase(): string {
    return isProd || !wpApiBase ? window.location.origin : wpApiBase;
  }

  static async getRoutes(): Promise<any> {
    const path = this.apiBase() + `/wp-json/wp/v2/routes`;
    const response = await axios.get(path);
    return response.data;
  }

  static async getRouteData(slug: string): Promise<RouteData> {
    const path = this.apiBase() + `/wp-json/wp/v2/get-page/?path=${slug}`;
    const response = await axios.get(path);
    return response.data;
  }

  static async getHomeData(): Promise<RouteData> {
    const path = this.apiBase() + `/wp-json/wp/v2/frontpage/`;
    const response = await axios.get(path);
    return response.data;
  }
}
